import React, { useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { useRouter } from 'next/router';
import { checkIsLoggedIn, getTravelAgency, getSiteHeaderVariant } from '../../../../store/slices/user';
import HeaderVariant from '../../../../constants/HeaderVariant';

const LoginButton = () => {
  const { isLoading } = useAuth0();
  const isLoggedIn = useSelector(checkIsLoggedIn);
  const travelAgency = useSelector(getTravelAgency);
  const headerVariant = useSelector(getSiteHeaderVariant);
  const { track } = useAnalytics();
  const router = useRouter();

  const doShowWithBranding = !isLoading && headerVariant === HeaderVariant.withBranding;

  const navbarLoginLinkText = useMemo(() => {
    const textFromConfig = travelAgency?.siteTheme?.navbarLoginLinkText;

    if (textFromConfig && textFromConfig.length) {
      return textFromConfig;
    }
    return doShowWithBranding ? 'TRAVEL AGENT LOGIN' : 'Login';
  }, [doShowWithBranding, travelAgency]);

  const handleLoginClick = () => {
    if (!isLoggedIn) {
      track('redirectToLogin_LoginButton');
      router.push(`/login?returnUrl=${encodeURIComponent(router.asPath)}`);
    }
  };

  const doHideAgentLoginLink = travelAgency?.settings?.doHideAgentLoginLink;

  if (isLoading || isLoggedIn || doHideAgentLoginLink) {
    return <></>;
  }

  return (
    <a
      tabIndex="-1"
      role="button"
      onKeyDown={handleLoginClick}
      onClick={handleLoginClick}
      title="Click to login"
      className="inline-block align-middle text-sm md:text-lg self-center"
    >
      <span>{navbarLoginLinkText}</span>
    </a>
  );
};

export default LoginButton;
